import styled from 'styled-components';
import colors from 'styles/colors';
export const DesktopLabel = styled.span``;
export const MobileLabel = styled.span``;

export const DropdownContainer = styled.div<{ $label: string }>`
  display: flex;
  flex-direction: column;
  position: relative;
  max-width: 240px;
  flex: 1;
  justify-content: flex-start;

  span {
    margin-right: auto;
    color: ${colors.grey['500']};
  }
  ${MobileLabel} {
    display: none;
  }

  @media (max-width: 640px) {
    ${({ $label }) => ($label === 'Speaker' || $label === 'Camera') && `display: none;`}
    ${DesktopLabel} {
      display: none;
    }
    ${MobileLabel} {
      display: block;
    }
  }
`;

export const DropdownList = styled.ul`
  position: absolute;
  left: 0;
  right: 0;
  background: white;
  border: 1px solid #ddd;
  border-radius: 4px;
  margin: 0;
  padding: 0;
  top: 100%;
  list-style: none;
  max-height: 150px;
  overflow-y: auto;
  z-index: 1000;

  @media (max-width: 640px) {
    max-height: 120px;
  }
`;

export const DropdownTrigger = styled.div<{ $devicesAvailable: boolean }>`
  border: 1px solid #ddd;
  display: flex;
  align-items: center;
  cursor: pointer;
  height: 46px;
  margin-top: 4px;
  background: #ffffff;
  border-radius: 4px;
  padding: 0 40px 0 20px;
  font-size: 16px;
  color: ${colors.blue['950']};
  position: relative;
  transition: all ease-in-out 0.1s;
  pointer-events: all;

  /* The trigger is a <button>; outrank parent rules such as InCall's Controls button
     (48x48, no border) that would otherwise hide the selected device. */
  && {
    box-sizing: border-box;
    width: 100%;
    height: 46px;
    border: 1px solid #ddd;
    font: inherit;
    font-size: 16px;
    text-align: left;
  }

  span {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: ${colors.blue['950']};
  }

  svg {
    position: absolute;
    right: 20px;
  }

  &:hover {
    background-color: ${colors.blue['50']};
  }

  &:focus-visible {
    outline: 2px solid #005fcc;
    outline-offset: 2px;
  }

  &:hover {
    background: rgba(255, 255, 255, 0.1);
  }

  &:active {
    background: rgba(255, 255, 255, 0.3);
  }
  ${({ $devicesAvailable }) => !$devicesAvailable && 'opacity:.5;'}
`;

export const DropdownListItem = styled.li`
  padding: 10px;
  cursor: pointer;
  border-bottom: 1px solid #eee;
  font-size: 16px;
  color: ${colors.blue['950']};
  transition: all ease-in-out 0.1s;

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    background-color: ${colors.blue['50']};
  }
`;
